async function authBack() {
    const asyncRequest = require("./asyncRequest");
    var options = {
        'method': 'POST',
        'url': `${process.env.API_URL}/auth/login`,
        'headers': {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "email": "root@neotix.com.br",
            "password": "N3ot!x1-APITYM"
        })

    };

    const token = await asyncRequest(options)
    return JSON.parse(token).access_token;
}

async function authFront() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
        "email": "root@neotix.com.br",
        "password": "N3ot!x1-APITYM"
    });

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
    };

    try {
        var response = await fetch(`${process.env.API_URL}/auth/login`, requestOptions)
        if(response.ok){
        // console.log(response.json()); //first consume it in console.log
       // return response.json(); //then consume it again, the error happens

       var result = await response.json()
        console.log('result', result)
       return result.access_token

   }

    }catch(err){
        console.log('err', err)
        return err
    }


}


module.exports = {
    authBack: authBack,
    authFront: authFront
}
